import {connect} from 'react-redux';
import {reduxForm} from 'redux-form';
import {ff, form} from "@mc/mc-legacy";
import {Component} from "react";
import * as React from "react";
const {Form, FormActions, FormBody} = form;
import CustomCheckboxField from "../../components/CustomCheckboxField";
import {withTranslation, WithTranslation} from "react-i18next";

/**
 * Formulář pro úpravu kontaktních údajů objednávky.
 */
class KontaktniInformaceForm extends Component<WithTranslation> {

    static formName = 'KontaktniInformaceForm';

    render() {
        const {onClose, submitting, handleSubmit, t} = this.props;
        return <Form onSubmit={handleSubmit} horizontal>
            <FormBody>
                <ff.String autocomplete={'off'} label={t('firstname')} name="uzivatelObjednalJmeno" disabled={submitting}/>
                <ff.String autocomplete={'off'} label={t('email')} name="email" disabled={submitting}/>
                <CustomCheckboxField label={t('notification_email')} name="notifikaceEmail" disabled={submitting}/>
                <ff.String autocomplete={'off'} label={t('phone')} name="telefon" disabled={submitting}/>
                <CustomCheckboxField label={t('notification_sms')} name="notifikaceSms" disabled={submitting}/>
            </FormBody>
            <FormActions onClose={onClose} storeButton={t('save')} cancelButton={t('buttons.cancel')} disabled={submitting}/>
        </Form>
    }
}

export default withTranslation()(connect()(reduxForm({
    form: KontaktniInformaceForm.formName,
})(KontaktniInformaceForm)));
